import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { push } from 'connected-react-router';

import Clock from './../Clock';
import Logo from './logo.png';
import themes from './themes';
import api from '../../api';

import ModalConfigDash from '../../components/ModalConfigDash';
import ModalLoginBySupervisor from '../../components/ModalLoginBySupervisor';

import {
  getAllDashboards,
  editDashboards,
  sidebarStateDashboards
} from '../../redux/actions/dashboards';
import {
  leave,
  authenticationsLogoutSuccess
} from '../../redux/actions/authentications';

const Header = () => {
  const dispatch = useDispatch();
  const expandButton = useRef();
  const [funcIsRunning, setFuncIsRunning] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowLogin, setModalShowLogin] = useState(false);
  const [showThemes, setShowThemes] = useState(false);

  const authentications = useSelector(state => state.authentications);
  const dashboards = useSelector(state => state.dashboards);
  const dash = useSelector(state => state.dashboards.currentDash);

  const handleClickMenu = () => {
    if (!funcIsRunning) {
      setFuncIsRunning(true);
      dispatch(sidebarStateDashboards(!dashboards.sidebarOpen));
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        setFuncIsRunning(false);
      }, 300);
    }
  };

  const handleClickThemes = () => {
    if (!showThemes) {
      const user = authentications.user._id;
      dispatch(getAllDashboards({ user }));
    }
    setShowThemes(!showThemes);
  };

  const fullScreen = () => {
    const fullScreenIcon = expandButton.current.firstChild;
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      fullScreenIcon.classList.add('active');
    } else {
      document.exitFullscreen();
      fullScreenIcon.classList.remove('active');
    }
  };

  const handleClickDash = () => {
    const user = authentications.user._id;
    dispatch(getAllDashboards({ user }));
    setModalShow(true);
  };

  const handleClickLogin = () => {
    setModalShowLogin(true);
  };

  const handleSwitchThemes = evt => {
    evt.preventDefault();
    if (!dashboards.isFetching && !dashboards.enableTransition) {
      const newThemeName = evt.target.getAttribute('data-theme');
      const user = authentications.user._id;
      const newDash = { ...dash, user, theme: newThemeName, selected: true };
      dispatch(editDashboards({ ...newDash }));
    }
  };

  const handleChangeDash = evt => {
    evt.preventDefault();
    if (!dashboards.isFetching) {
      const { value } = evt.target;
      const currentDash = dashboards.data.find(dash => dash._id === value);
      dispatch(editDashboards({ ...currentDash, selected: true }));
    }
  };

  const handleClickLogout = () => {
    try {
      const options = document.getElementById('currentExtension').options;
      const logoutsExtensions = [];
      for (const op of options) {
        logoutsExtensions.push({ extension: op.value, idExtension: op.id });
      }
      logoutsExtensions.forEach(async obj => {
        await api().post('/api/devices/logout_extension', obj);
      });
    } catch (err) {
      console.error(err);
    } finally {
      const userId = authentications.user._id;
      dispatch(leave({ userId }));
    }
  };

  useEffect(() => {
    const timer = setInterval(async () => {
      try {
        const session = localStorage.getItem('session') || '';
        const obj = { session };
        const response = await api().post('/api/auth/verify_session', obj);
        const { status, departments } = response.data;
        if (status === 'failure') {
          dispatch(authenticationsLogoutSuccess(response));
          dispatch(push('/'));
        } else {
          // update session
          const user = JSON.parse(localStorage.getItem('user'));
          if (departments.length !== user.departments.length) {
            localStorage.setItem(
              'user',
              JSON.stringify({ ...user, departments })
            );
          } else if (departments.length === user.departments.length) {
            for (const id of departments) {
              if (!user.departments.includes(id)) {
                localStorage.setItem(
                  'user',
                  JSON.stringify({ ...user, departments })
                );
                break;
              }
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
    }, 10000);

    return () => {
      clearInterval(timer);
    };
  }, [dispatch]);

  return (
    <React.Fragment>
      <ModalConfigDash modalShow={modalShow} setModalShow={setModalShow} />
      <ModalLoginBySupervisor
        modalShowLogin={modalShowLogin}
        setModalShowLogin={setModalShowLogin}
      />

      <nav
        id="navbar"
        className={`navbar navbar-expand fixed-top navbar-bg ${dash.theme}`}
      >
        <div className="nav-main">
          <ul className="navbar-nav nav-main-pos">
            <li className="nav-item-h" onClick={handleClickMenu}>
              <span className="nav-link mr-3">
                <i
                  className={`fa ${
                    dashboards.sidebarOpen ? 'fa-outdent' : 'fa-indent'
                  } color-menu`}
                  aria-hidden="true"
                ></i>
              </span>
            </li>
            <li className="nav-item-h nav-logo">
              <span className="nav-link mr-3">
                <img src={Logo} width="136" height="47" alt="4Case Solutions" />
              </span>
            </li>
            <li
              className="nav-item-h"
              onClick={fullScreen}
              title="Entrar/Sair do Modo Tela Cheia"
            >
              <span ref={expandButton} className="nav-link mr-3 expand-screen">
                <i className="fas fa-expand-arrows-alt"></i>
              </span>
            </li>
          </ul>
        </div>
        <div className="ml-auto nav-clock">
          <Clock />
        </div>
        <ul className="navbar-nav ml-auto right-btn">
          {['M', 'S'].includes(authentications.user.type) && (
            <React.Fragment>
              <li className="nav-item-h" title="Vincular usuário ao ramal">
                <button type="button" onClick={handleClickLogin}>
                  <span className="nav-link mr-3 right-span">
                    <i className="fas fa-user-plus"></i>
                  </span>
                </button>
              </li>
              <li className="nav-item-h" title="Dashboard">
                <button type="button" onClick={handleClickDash}>
                  <span className="nav-link mr-3 right-span">
                    <i className="far fa-window-restore"></i>
                  </span>
                </button>
              </li>
            </React.Fragment>
          )}
          <li className="nav-item-h" title="Temas">
            <button type="button" onClick={handleClickThemes}>
              <span className="nav-link mr-3 right-span">
                <i
                  className={`fa fa-paint-brush ${showThemes ? 'active' : ''}`}
                ></i>
              </span>
            </button>
          </li>
          <li className="nav-item-h" title="Sair">
            <button
              type="button"
              onClick={handleClickLogout}
              disabled={authentications.isFetching}
            >
              <span className="nav-link mr-3 right-span">
                <i className="fa fa-power-off"></i>
              </span>
            </button>
          </li>
        </ul>
      </nav>
      <Card className={`card-themes text-center ${showThemes ? 'active' : ''}`}>
        <Card.Body className="active">
          <h5>Temas</h5>
          <div>
            {themes.map((theme, i) => {
              if (dash.theme === theme.name) {
                localStorage.setItem('theme', theme.name);
              }
              return (
                <Link
                  key={i}
                  to="/"
                  onClick={handleSwitchThemes}
                  title={theme.label}
                  data-theme={theme.name}
                  className={`theme-option theme ${theme.name} ${
                    dash.theme === theme.name ? 'selected' : ''
                  }`}
                />
              );
            })}
          </div>
          <div>
            <h5>Selecionar Dashboard</h5>
            <div className="form-group mr-2 ml-2">
              <select
                className="form-control"
                value={dash._id}
                onChange={handleChangeDash}
                disabled={
                  dashboards.data.length < 2 ||
                  dashboards.isFetching ||
                  dashboards.enableTransition
                }
              >
                {dashboards.data.map(item => {
                  return (
                    <option value={item._id} key={item._id}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default Header;
